import apiBaseUrlList from "../config/apiBaseUrlList";
import BaseUrl from "../types/BaseUrl";
import IApiEndpoint from "../types/IApiEndpoint";
import ISelectedExtra from "../types/ISelectedExtra";

export default function getApiEndpointUrl(
  baseUrl: BaseUrl,
  apiVersion: number,
  apiEndpoint: IApiEndpoint,
  parameters?: Record<string, string | number | ISelectedExtra>
): string {
  parameters = {
    apiVersion: `v${apiVersion}`,
    vendor: baseUrl.getDomain(),
    ...parameters
  };

  const url = new URL(
    getApiEndpointPath(apiEndpoint.pathTemplate, parameters),
    getApiBaseUrl(baseUrl.getEnvironment())
  );
  return url.href;
}

// replace variables with format ${variableName} in pathTemplate based on parameter keys
function getApiEndpointPath(
  pathTemplate: string,
  parameters?: Record<string, string | number | ISelectedExtra>
): string {
  Object.keys(parameters).forEach((key) => {
    pathTemplate = pathTemplate.replace(`\$\{${key}\}`, parameters[key].toString());
  });

  return pathTemplate;
}

// replace variables with format ${variableName} in pathTemplate based on parameter keys
function getApiBaseUrl(environment: string): string {
  return apiBaseUrlList[environment];
}
